import React, { useState, useEffect, useContext } from "react";
import "./Toast.css";
import checkIcon from "./ToastIcons/success-grey.svg";
import cancelIcon from "./ToastIcons/cancel.svg";
import studyviewerContext from "../../context/studyviewer/StudyviewerContext";
import CustomToolTipHost from "../CustomToolTipHost/CustomToolTipHost";
import { historyDownload } from "../../service/StudyViewerService";
import themeContext from "../../context/theme/ThemeContext";
import Download from "../SVGComponents/Tools/Download";
import EyeIcon from "../SVGComponents/EyeIcon";
import ThumbnailContext from "../../context/studyviewer/ThumbnailContext";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { getStudyCommunicationData } from "../../service/CommunicationService";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import { t } from "i18next";
import GreyTickNotification from "../SVGComponents/GreyTickNotification";
import CancelNotification from "../SVGComponents/CancelNotification";

import { USERTYPES } from "../../constants/Constants";
import userContext from "../../context/users/UserContext";

const ViewerStartToast = () => {
  const {
    showStartAlertToast,
    setShowStartAlertToast,
    setOneTimeShowAlertDone,
    typistShowHistory,
  } = useContext(studyviewerContext);

  const {
    roles,
  } = useContext(userContext);

  const [progress, setProgress] = useState(100);
  const [timer, setTimer] = useState(null);
  const [remainingTime, setRemainingTime] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress > 0) {
          return prevProgress - 1;
        } else {
          clearInterval(interval);
          return 0;
        }
      });
    }, 100);

    setTimer(interval);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleHover = () => {
    if (timer) {
      clearInterval(timer);
      setRemainingTime(progress); // Store the remaining time
    }
  };

  const handleHoverOut = () => {
    if (!timer || remainingTime) {
      const newTimer = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress > 0) {
            return prevProgress - 1;
          } else {
            clearInterval(newTimer);
            return 0;
          }
        });
      }, 100);
      setTimer(newTimer);

      if (remainingTime !== null) {
        const remainingTimer = setTimeout(() => {
          setProgress(remainingTime - 1);
          clearInterval(remainingTimer);
        }, 100);
      }
    }
  };

  useEffect(() => {
    if (progress === 0) {
      setShowStartAlertToast(false);
    }
  }, [progress, remainingTime]);

  return (
    <>
      {(roles[0] != USERTYPES.TYPIST || (roles[0] == USERTYPES.TYPIST && typistShowHistory) ) && <div id="toast-parent" className="notification-container top-right">
        <div
          className="notification notification-background toast"
          onMouseEnter={handleHover}
          onMouseLeave={handleHoverOut}
          style={{ width: "288px", position: "relative", borderRadius: "15px" }}
        >
          <div
            style={{
              paddingTop: "10px",
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "space-between",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", flex: "5" }}>
                <div style={{ marginRight: "10px" }}>
                  {/* <img src={checkIcon} alt="" /> */}
                  <GreyTickNotification />
                </div>
                <div className="notification-title notification-title-viewer">
                  {t("heading.notification").toUpperCase()}
                </div>
              </div>
              <div
                style={{ display: "flex", alignItems: "start" }}
                onClick={() => {setShowStartAlertToast(false)}}
              >
                {/* <img src={cancelIcon} alt="" /> */}
                <CancelNotification />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0px 4px",
                marginBottom: "10px",
              }}
            >
              <ClinicalToastBox
                setShowStartAlertToast={setShowStartAlertToast}
              />
              <CommunicationToastBox
                setShowStartAlertToast={setShowStartAlertToast}
              />
              <AttachmentToastBox
                setShowStartAlertToast={setShowStartAlertToast}
              />
            </div>
          </div>
          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{ width: `${100 - progress}%` }}
            ></div>
          </div>
        </div>
      </div>}
    </>
  );
};

export default ViewerStartToast;

export const CommunicationToastBox = (props) => {
  const {
    messageCount,
    studyParentId,
    studyClinicalNotesData,
    studyHistoryData
  } = useContext(studyviewerContext);
  const {  showCommunicationModal,setShowCommunicationModal } = useContext(studyReportContext);
  const { themeName, getAlterColor } = useContext(themeContext);
  const { activeModality, activeStudyId } = useContext(ThumbnailContext);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);

  const getDynamicMessageValue = () => {
    if(studyClinicalNotesData.length == 0 && studyHistoryData != undefined && studyHistoryData != null && studyHistoryData.length == 0){
      return 10;
    }else{
      return 2;
    }
  }

  const getCommunicationData = async () => {
    setLoading(true);
    const res = await getStudyCommunicationData(studyParentId);
    if (res.status == 200 && res.data.result == "SUCCESS") {
      setMessages(res.data.data);

      setLoading(false);
    } else {
      setLoading(false);
    }
    
  };

  useEffect(() => {
    getCommunicationData();
  }, []);

  const customSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  const customColumnTooltip = {
    root: "toast-box-message",
  }

  function timeAgo(timestamp) {
    const currentDate = new Date();
    const messageDate = new Date(timestamp);

    // Calculate the difference in milliseconds
    const difference = currentDate - messageDate;

    // Convert milliseconds to minutes
    const minutes = Math.floor(difference / (1000 * 60));

    if (minutes < 1) {
        return "Just now";
    } else if (minutes < 60) {
        return `${minutes}m ago`;
    } else if (minutes < 1440) { // 1440 minutes in a day
        const hours = Math.floor(minutes / 60);
        return `${hours}h ago`;
    } else {
        const days = Math.floor(minutes / 1440);
        return `${days}d ago`;
    }
}

const handleShowCommunicationModal = () => {
    props.setShowStartAlertToast(false);
    setShowCommunicationModal(true);
}

  return (
    <>
      {messageCount > 0 ? (
        <div className={`${themeName == "light" ? "toast-box-container-light":"toast-box-container"}`}>
          <span className="toast-box-title">{t("heading.communication").toUpperCase()}</span>
          {!loading && (
            <>
              {messages.slice().reverse().map((message, index) => {
                if(index < getDynamicMessageValue()){
                    return (
                        <div key={index} style={{display:'flex',justifyContent:'space-between'}}>
                        <CustomToolTipHost
                        styles={customColumnTooltip}
                        content={`${message.user.firstName} ${message.user.lastName}: ${message.feedback}`}
                        id="toast-box-id"
                      ><span className="toast-box-content" style={{color: getAlterColor("#b7b7b7","rgb(59 59 59)")}}>
                        {`${message.user.firstName} ${message.user.lastName}`}
                        :&nbsp;
                        <span className="toast-box-message-value">
                           {message.feedback}
                        </span>
                      </span> </CustomToolTipHost>
                      <span className="toast-box-date">{timeAgo(message.feedbackDate)}</span>
                      </div>
                    );
                }
              })}
              {messages?.length > getDynamicMessageValue() && (
              <span
                onClick={handleShowCommunicationModal}
                className="toast-box-more-text"
              >
                {messages?.length - getDynamicMessageValue()} more unread
              </span>
            )}
            </>
          )}
          {loading && (
            <div>
              <Spinner size={SpinnerSize.large} styles={customSpinnerStyle} />
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export const ClinicalToastBox = (props) => {
  const {
    studyData,
    messageCount,
    patientStudyData,
    studyModality,
    studyHistoryData,
    studyClinicalNotesData,
    studyParentId,
    assignmentData,
    setSwitchingToBasic,
    parentChildReportsObj,
    setShowClinicalNotes,
    getMessageCount,
    studyParentAssignmentData,
  } = useContext(studyviewerContext);
  const { activeModality, activeStudyId } = useContext(ThumbnailContext);
  const { themeName,getAlterColor } = useContext(themeContext);
  const checkForClinicalNotesAvailable = () => {
    const advanceViewer = window.location.pathname.includes(
      "nonXrayAdvanceViewer"
    );
    if (advanceViewer) {
      return studyClinicalNotesData;
    }
    if (
      activeStudyId != "" &&
      studyParentId != null &&
      studyParentId != undefined
    ) {
      if (activeStudyId == studyParentId) {
        return studyClinicalNotesData.length > 0;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.history != undefined &&
          parentChildReportsObj[activeStudyId]?.history != null
        ) {
          return parentChildReportsObj[activeStudyId]?.history.length > 0;
        }
        return false;
      }
    }
  };

  const getStudyClinicalData = () => {
    const advanceViewer = window.location.pathname.includes(
      "nonXrayAdvanceViewer"
    );
    if (advanceViewer) {
      return studyClinicalNotesData;
    }
    if (
      activeStudyId != "" &&
      studyParentId != null &&
      studyParentId != undefined
    ) {
      if (activeStudyId == studyParentId) {
        return studyClinicalNotesData;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.history != undefined &&
          parentChildReportsObj[activeStudyId]?.history != null
        ) {
          return parentChildReportsObj[activeStudyId]?.history;
        }
        return false;
      }
    }
  };

  const handleShowClinicalNotes = () => {
    props.setShowStartAlertToast(false);
    setShowClinicalNotes(true);
  }
  function trimText(data,maxLength) {
    // If the length of data is less than or equal to maxLength, return the original text
    if (data.length <= maxLength) {
      return data;
    }
  
    // Otherwise, trim the text to maxLength characters and append ellipsis (...) to indicate that the text has been trimmed
    return data.substring(0, maxLength) + '...';
  }

  return (
    <>
      {checkForClinicalNotesAvailable() ? (
        <div className={`${themeName == "light" ? "toast-box-container-light":"toast-box-container"}`}>
          <span className="toast-box-title">
            {t("heading.clinical-notes").toUpperCase()}
          </span>
          <span className="toast-box-content" style={{color: getAlterColor("#b7b7b7","rgb(59 59 59)")}}>
            {trimText(getStudyClinicalData(), 250)}
          </span>
          <span>
          {getStudyClinicalData().length > 250 && <span
                onClick={handleShowClinicalNotes}
                className="toast-box-more-text"
              >Show More</span>}
          </span>
        </div>
      ) : (
        <div className={`${themeName == "light" ? "toast-box-container-light":"toast-box-container"}`} style={{cursor:'not-allowed'}}>
          <span className="toast-box-title">
            {t("heading.clinical-notes").toUpperCase()}
          </span>
          <span className="toast-box-content" style={{color: getAlterColor("#b7b7b7","rgb(59 59 59)")}}>
            {t("search-message.no-clinical-notes")}
          </span>
        </div>
      )}
    </>
  );
};

export const AttachmentToastBox = (props) => {
  const {
    studyHistoryData,
    studyParentId,
    parentChildReportsObj,
    setShowAttachment,
  } = useContext(studyviewerContext);
  const { activeModality, activeStudyId } = useContext(ThumbnailContext);
  const { themeName,getAlterColor } = useContext(themeContext);
  const handleShowAttachment = () => {
    props.setShowStartAlertToast(false);
    setShowAttachment(true);
  };

  const getStudyHistoryData = () => {
    const advanceViewer = window.location.pathname.includes(
      "nonXrayAdvanceViewer"
    );
    if (advanceViewer) {
      return studyHistoryData;
    }
    if (
      activeStudyId != "" &&
      studyParentId != null &&
      studyParentId != undefined
    ) {
      if (activeStudyId == studyParentId) {
        return studyHistoryData;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.studyHistoryDocList != undefined
        ) {
          return parentChildReportsObj[activeStudyId]?.studyHistoryDocList;
        }
        return false;
      }
    }
  };

  const studyHistoryDataTemp = getStudyHistoryData();

  const checkForHistoryDocsAvailable = () => {
    const advanceViewer = window.location.pathname.includes(
      "nonXrayAdvanceViewer"
    );
    if (advanceViewer) {
      return studyHistoryData?.length > 0 ? true: false;
    }
    if (
      activeStudyId != "" &&
      studyParentId != null &&
      studyParentId != undefined
    ) {
      if (activeStudyId == studyParentId) {
        return studyHistoryData?.length > 0;
      } else {
        if (
          parentChildReportsObj[activeStudyId]?.studyHistoryDocList != undefined
        ) {
          return (
            parentChildReportsObj[activeStudyId]?.studyHistoryDocList.length > 0
          );
        }
        return false;
      }
    }
  };

  const getFileName = (str) => {
    let s = str.lastIndexOf("/");
    if (s != -1) {
      return str.substring(s + 1);
    }
    return "";
  };

  function getFileExtension(filename) {
    const extension = filename.split(".").pop();
    return extension;
  }

  const printPreviewHistoryDoc = async (historyDoc) => {
    let n = historyDoc.indexOf("/");
    let bucketName = historyDoc.substring(0, n);
    let result = historyDoc.substring(n + 1);
    let extension = getFileExtension(getFileName(result));
    let body = {
      studyId: studyParentId,
      filePath: result,
      bucketName: bucketName,
    };
    try {
      let res = await historyDownload(body, extension);
    } catch (e) {}
  };

  return (
    <>
      {checkForHistoryDocsAvailable() ? (
        <div className={`${themeName == "light" ? "toast-box-container-light":"toast-box-container"}`}>
          <span className="toast-box-title">{t("heading.attachments").toUpperCase()}</span>
          <ul className="dropdown-menu-history scrollable-menu modal-scroll-annotation">
            {getStudyHistoryData()?.map((report, index) => {
              if (index < 2) {
                return (
                  <li
                    style={{ margin: "5px 0px" }}
                    key={index}
                    onClick={(event) => {
                      printPreviewHistoryDoc(studyHistoryDataTemp[index]);
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <CustomToolTipHost
                        content={`${getFileName(report)}`}
                        id="View Report"
                      >
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <a
                            style={{ color: getAlterColor("#A19F9D", "#000"),width:"213px" }}
                            className="report-name-text"
                          >
                            {getFileName(report)}
                          </a>
                        </span>
                      </CustomToolTipHost>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {getFileExtension(getFileName(report)) == "doc" ||
                        getFileExtension(getFileName(report)) == "docx" ? (
                          <Download color={getAlterColor("#C1C1C1", "")} />
                        ) : (
                          <EyeIcon color={getAlterColor("#C1C1C1", "")} />
                        )}
                      </span>
                    </div>
                  </li>
                );
              }
            })}
            {getStudyHistoryData()?.length > 2 && (
              <span
                onClick={handleShowAttachment}
                className="toast-box-more-text"
              >
                {getStudyHistoryData()?.length - 2} more unread
              </span>
            )}
          </ul>
        </div>
      ) : (
        <div className={`${themeName == "light" ? "toast-box-container-light":"toast-box-container"}`} style={{cursor:'not-allowed'}}>
          <span className="toast-box-title">
          {t("heading.attachments").toUpperCase()}
          </span>
          <span className="toast-box-content" style={{color: getAlterColor("#b7b7b7","rgb(59 59 59)")}}>
            {t("search-message.no-attachment")}
          </span>
        </div>
      )}
    </>
  );
};
